/* Field park: the comment sits in the field anatomy until the editor round's markdown field. */
import { Field } from '@main/complykit/components/field';
import { Vendor_Questionnaire_Form_Answer_Statuses_Enum } from '@main/graphql/types.generated';
import { MarkdownEditor } from '@main/ui';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  QuestionnaireFormFieldConfig,
  QuestionnnaireFieldWrapperProps,
  QuestionnnaireFormFieldAnswer,
  QuestionnnaireFormMode,
} from './form-types';

export const QuestionnaireFieldCommentPrefix = 'comment:';

export interface QuestionnaireFieldCommentProps extends QuestionnnaireFieldWrapperProps {
  config: QuestionnaireFormFieldConfig;
  answer: QuestionnnaireFormFieldAnswer;
}

export function QuestionnaireFieldComment(props: QuestionnaireFieldCommentProps) {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const isAnswerMode = props.form.mode === QuestionnnaireFormMode.Answer;
  const isCompleted =
    props.answer.status === Vendor_Questionnaire_Form_Answer_Statuses_Enum.Completed;
  const isReadOnly = isCompleted || !isAnswerMode;

  return (
    <Field label={t('questionnaires.form.commentLabel')} isReadOnly={isReadOnly}>
      {(fieldControl) => (
        <Controller<{
          [commentKey: `comment:${string}`]: string;
        }>
          name={`${QuestionnaireFieldCommentPrefix}${props.config.name}`}
          control={control}
          defaultValue={props.answer.comment ?? ''}
          render={({ field }) => (
            <MarkdownEditor
              value={field.value}
              config={{ editable: !isReadOnly }}
              onValueChange={(value) => field.onChange(value)}
              onBlur={() => field.onBlur()}
              variant={isReadOnly ? 'unstyled' : 'textarea'}
              placeholder={t('questionnaires.form.commentPlaceholder')}
              contentEditableProps={{
                ...fieldControl,
                'data-testid': `${props.config.label}-comment-content-editable`,
              }}
            />
          )}
        />
      )}
    </Field>
  );
}
